// Do not modify. This is generated code.

import {
  Account,
  Alert,
  Aqc,
  Area_code,
  Arrow_45,
  Arrow_down,
  Arrow,
  Atm,
  Attachment,
  Bag,
  Blog,
  Bswh_symbol,
  Building,
  Calendar,
  Camera,
  Car,
  Chat,
  Check,
  Chevron_down,
  Chevron_left,
  Chevron_right,
  Chevron_up,
  Chip,
  Clipboard,
  Clock,
  Copy,
  Covid_19,
  Credentials,
  Credit_card,
  Dining_options,
  Directions,
  Docs_folder,
  Dot,
  Download,
  Edit,
  Ellipsis,
  Exclamation,
  Expand,
  Facebook,
  Favorite_filled,
  Favorite,
  Find_care,
  Globe,
  Grid,
  Hamburger,
  Help_center,
  Help,
  Help2,
  Information,
  Instagram,
  Insurance,
  Linkedin,
  Location,
  Logout,
  Mask,
  Medical,
  Medications,
  Message_notification,
  Message,
  Minimize,
  Minus,
  Money,
  Multilingual,
  Mute,
  My_location,
  New_patient,
  No_patient,
  Parking,
  Patient,
  Pause,
  Phone,
  Pinterest,
  Play,
  Plus,
  Post_office,
  Prescription,
  Printer,
  Proxy,
  Question,
  Recent_search,
  Reset,
  Resource,
  Results,
  Search_doctors,
  Search_locations,
  Search_medical_records,
  Search,
  Secure,
  Security,
  Service,
  Settings,
  Share,
  Sort_order,
  Sort,
  Star,
  Tab_chip,
  Testing,
  Text_reminders,
  Trash,
  Twitter,
  Unmute,
  Vaccine,
  Video_visit,
  Visibility_off,
  Visibility_on,
  Visitor_lounge,
  Wallet,
  Weather,
  X,
  Youtube,
  SystemIconNameAvailable,
  SystemIconNameDeprecated
} from './SystemIconsTypes.generated';

import * as React from 'react';

export interface GeneratedSystemIconProps {
  color?: string;
  fill?: string;
  height?: number;
  icon?: SystemIconNameAvailable | SystemIconNameDeprecated;
  width?: number;
}

const GeneratedSystemIconMap = {
  ['account']: Account,
  ['alert']: Alert,
  ['aqc']: Aqc,
  ['area-code']: Area_code,
  ['arrow-45']: Arrow_45,
  ['arrow-down']: Arrow_down,
  ['arrow']: Arrow,
  ['atm']: Atm,
  ['attachment']: Attachment,
  ['bag']: Bag,
  ['blog']: Blog,
  ['bswh-symbol']: Bswh_symbol,
  ['building']: Building,
  ['calendar']: Calendar,
  ['camera']: Camera,
  ['car']: Car,
  ['chat']: Chat,
  ['check']: Check,
  ['chevron-down']: Chevron_down,
  ['chevron-left']: Chevron_left,
  ['chevron-right']: Chevron_right,
  ['chevron-up']: Chevron_up,
  ['chip']: Chip,
  ['clipboard']: Clipboard,
  ['clock']: Clock,
  ['copy']: Copy,
  ['covid-19']: Covid_19,
  ['credentials']: Credentials,
  ['credit-card']: Credit_card,
  ['dining-options']: Dining_options,
  ['directions']: Directions,
  ['docs-folder']: Docs_folder,
  ['dot']: Dot,
  ['download']: Download,
  ['edit']: Edit,
  ['ellipsis']: Ellipsis,
  ['exclamation']: Exclamation,
  ['expand']: Expand,
  ['facebook']: Facebook,
  ['favorite-filled']: Favorite_filled,
  ['favorite']: Favorite,
  ['find-care']: Find_care,
  ['globe']: Globe,
  ['grid']: Grid,
  ['hamburger']: Hamburger,
  ['help-center']: Help_center,
  ['help']: Help,
  ['help2']: Help2,
  ['information']: Information,
  ['instagram']: Instagram,
  ['insurance']: Insurance,
  ['linkedin']: Linkedin,
  ['location']: Location,
  ['logout']: Logout,
  ['mask']: Mask,
  ['medical']: Medical,
  ['medications']: Medications,
  ['message-notification']: Message_notification,
  ['message']: Message,
  ['minimize']: Minimize,
  ['minus']: Minus,
  ['money']: Money,
  ['multilingual']: Multilingual,
  ['mute']: Mute,
  ['my-location']: My_location,
  ['new-patient']: New_patient,
  ['no-patient']: No_patient,
  ['parking']: Parking,
  ['patient']: Patient,
  ['pause']: Pause,
  ['phone']: Phone,
  ['pinterest']: Pinterest,
  ['play']: Play,
  ['plus']: Plus,
  ['post-office']: Post_office,
  ['prescription']: Prescription,
  ['printer']: Printer,
  ['proxy']: Proxy,
  ['question']: Question,
  ['recent-search']: Recent_search,
  ['reset']: Reset,
  ['resource']: Resource,
  ['results']: Results,
  ['search-doctors']: Search_doctors,
  ['search-locations']: Search_locations,
  ['search-medical-records']: Search_medical_records,
  ['search']: Search,
  ['secure']: Secure,
  ['security']: Security,
  ['service']: Service,
  ['settings']: Settings,
  ['share']: Share,
  ['sort-order']: Sort_order,
  ['sort']: Sort,
  ['star']: Star,
  ['tab-chip']: Tab_chip,
  ['testing']: Testing,
  ['text-reminders']: Text_reminders,
  ['trash']: Trash,
  ['twitter']: Twitter,
  ['unmute']: Unmute,
  ['vaccine']: Vaccine,
  ['video-visit']: Video_visit,
  ['visibility-off']: Visibility_off,
  ['visibility-on']: Visibility_on,
  ['visitor-lounge']: Visitor_lounge,
  ['wallet']: Wallet,
  ['weather']: Weather,
  ['x']: X,
  ['youtube']: Youtube,
};

export const GeneratedSystemIcon = (props: GeneratedSystemIconProps) => {
  const Component = GeneratedSystemIconMap[props.icon!];
  if (!Component) {
    throw new Error('icon "' + props.icon + '" not found in set "system"');
  }
  return <Component {...props} />;
};
